// Comportamenti condivisi delle pagine prodotto (layout 2026): Alicon, Mixer, tr.asset, Cleve.
// Estratto da cleve-2026.js perché generico a qualunque pagina prodotto, non specifico di Cleve.
// Stato avanzamento: vedi docs/2026-layout-CHANGELOG.md

/* ── FAQ accordion — una sola aperta alla volta ─────────────── */
(function () {
    'use strict';
    var items = Array.prototype.slice.call(document.querySelectorAll('.faq-item'));
    if (!items.length) return;

    function closeAll() {
        items.forEach(function (o) {
            o.classList.remove('is-open');
            var b = o.querySelector('.faq-q');
            if (b) b.setAttribute('aria-expanded', 'false');
        });
    }

    items.forEach(function (item) {
        var btn = item.querySelector('.faq-q');
        if (!btn) return;
        btn.addEventListener('click', function () {
            var wasOpen = item.classList.contains('is-open');
            closeAll();
            if (!wasOpen) {
                item.classList.add('is-open');
                btn.setAttribute('aria-expanded', 'true');
            }
        });
    });
})();

/* ── CTA form: riordina il campo "Cosa fai principalmente" prima del messaggio ──
   Il select #activity è specifico di ogni pagina prodotto (non fa parte del partial
   contacts::_fields condiviso), aggiunto dopo di esso nel markup — quindi arriva
   dopo messaggio/privacy. Lo spostiamo via DOM (non con CSS `order`, che
   lascerebbe l'ordine di tabulazione da tastiera diverso da quello visivo) per
   farlo comparire subito prima del campo messaggio, come nella proposta. */
(function () {
    var activityRow = document.getElementById('activity') && document.getElementById('activity').closest('.row');
    var messageField = document.getElementById('message');
    var messageRow = messageField && messageField.closest('.row');
    if (activityRow && messageRow && messageRow.parentNode) {
        messageRow.parentNode.insertBefore(activityRow, messageRow);
    }
})();

/* ── Hero visual "a cycle" — alterna in dissolvenza più immagini (.hero-cycle) ──
   Generico e agnostico al numero di immagini: per configurare il loop di una pagina
   prodotto basta aggiungere/togliere/rinominare i tag <img class="hero-cycle-img">
   dentro il contenitore .hero-cycle (markup + CSS in _hero-visual-*-2026.blade.php /
   _product-2026.scss) — nessuna modifica qui. Con una sola immagine non fa nulla (resta
   statica). Rispetta prefers-reduced-motion: reduce, come .btn--comet e la flowmap di
   Cleve — nessuna alternanza, resta ferma sulla prima immagine (quella "is-active" nel
   markup). */
(function () {
    'use strict';
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var containers = Array.prototype.slice.call(document.querySelectorAll('.hero-cycle'));
    containers.forEach(function (container) {
        var images = Array.prototype.slice.call(container.querySelectorAll('.hero-cycle-img'));
        if (images.length < 2) return;

        var interval = parseInt(container.getAttribute('data-interval'), 10) || 4000;
        var current = images.findIndex(function (img) { return img.classList.contains('is-active'); });
        if (current === -1) {
            current = 0;
            images[0].classList.add('is-active');
        }

        setInterval(function () {
            var next = (current + 1) % images.length;
            images[current].classList.remove('is-active');
            images[next].classList.add('is-active');
            current = next;
        }, interval);
    });
})();
